import { render } from "./Downloads.html?vue&type=template&id=07d792cc&scoped=true&ts=true"
import script from "./Downloads.ts?vue&type=script&lang=ts"
export * from "./Downloads.ts?vue&type=script&lang=ts"

import "./Downloads.scss?vue&type=style&index=0&id=07d792cc&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d792cc"]])

export default __exports__